export const themeConfig = {
  cssVar: true,
  token: {
    colorPrimary: '#000000',
    colorInfo: '#000000',
    colorPrimaryBg: '#4040403b',
    colorPrimaryBgHover: '#4040403b',
  },
  components: {
    Table: {
      cellFontSize: 12,
      cellFontSizeSM: 12,
    },
    Divider: {
      marginLG: 8,
      margin: 8,
      colorSplit: 'rgba(80,65,65,0.38)',
      fontSize: 12,
    },
    Layout: {
      footerPadding: '12px 50px',
    },
    Pagination: {
      margin: 4,
    },
  },
};
